"use client";
import CommonCMS from "@lib/constants/contentful/cms-common";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { H } from "@ecco/ui/a11y-heading";
import { Flex } from "@ecco/ui/flex";
import type { FC } from "react";

export const NotLoggedIn: FC = () => {
    const { get: getMicrocopy } = useMicrocopy();

    return (
        <Flex bg="gray.50" w="full" px={[4, 4, 16]} py={[6, 6, 12]} justifyContent="center">
            <H size="h3">{getMicrocopy(CommonCMS.shared, CommonCMS.notLoggedIn)}</H>
        </Flex>
    );
};
